module.exports = __webpack_public_path__ + "static/media/circulation_state_diagram.94d03389.jpg";